const addInfo = {
    title: 'GpsTracking',
    icon: 'GpsTracking'
}
const GPSTrackingRouter = {
    path: '/gps-tracking',
    meta: {
        title: 'GpsTracking',
        icon: 'GpsTracking',
        permission: ['gps_tracking']
    },
    children: [
        {
            path: 'full-map-tracking/:id?',
            component: () => import('@/views/GPS-Tracking/FullMapTracking/full-map-tracking.vue'),
            name: 'FullMapTracking',
            meta: { title: 'FullMapTracking', parent: addInfo, permission: ['real_time_tracking_map_enable'] }
        },
        {
            path: 'live-video-history/:id?',
            component: () => import('@/views/GPS-Tracking/FullMapTracking/live-video-history'),
            name: 'VideoHistoricalPlayback',
            hidden: true,
            meta: { title: 'VideoHistoricalPlayback', parent: addInfo, enableBack: true, backPage: 'FullMapTracking', activeMenu: '/gps-tracking/full-map-tracking' }
        },  //permission
        {
            path: 'multi-vehicle-tracking',
            component: () => import('@/views/GPS-Tracking/MultiVehicleTracking/multi-vehicle-tracking.vue'),
            name: 'MultiVehicleTracking',
            meta: { title: 'MultiVehicleTracking', parent: addInfo, permission: ['multiple_vehicle_tracking_map_enable'] }
        },
        {
            path: 'vehicle-tracking-list',
            component: () => import('@/views/GPS-Tracking/VehicleTrackingList/vehicle-tracking-list.vue'),
            name: 'VehicleTrackingList',
            meta: { title: 'VehicleTrackingList', parent: addInfo, permission: ['vehicle_tracking_list_enable'] }
        },
        {
            path: 'manage-sharable-link-list',
            component: () => import('@/views/GPS-Tracking/ManageSharableLink/manage-sharable-link.vue'),
            name: 'ManageSharableLinkList',
            meta: { title: 'ManageSharableLinkList', parent: addInfo, permission: ['sharable_link_management'] }
        },
        {
            path: 'historical-playback/:id?',
            component: () => import('@/views/GPS-Tracking/HistoricalPlayback/historical-playback-details.vue'),
            name: 'HistoricalPlaybackDetails',
            meta: { title: 'HistoricalPlayback', activeMenu: '/gps-tracking/historical-playback', parent: addInfo, permission: ['historical_playback_enable'] }
        },
        {
            path: 'live-video/:id?',
            component: () => import('@/views/GPS-Tracking/FullMapTracking/live-video'),
            name: 'LiveVideo',
            meta: { title: 'LiveVideo', parent: addInfo, enableBack: true, backPage: 'FullMapTracking', activeMenu: '/gps-tracking/full-map-tracking' }
        },  //permission
        {
            path: 'poi-management',
            component: () => import('@/views/GPS-Tracking/PoiManagement/poi-management.vue'),
            name: 'PoiManagement',
            meta: { title: 'PoiManagement', parent: addInfo, permission: ['poi_enable'] }
        },
        {
            path: 'create-poi-form',
            component: () => import('@/views/GPS-Tracking/PoiManagement/poi-form'),
            name: 'PoiForm',
            hidden: true,
            meta: {
                title: 'PoiForm',
                activeMenu: '/gps-tracking/poi-management',
                parent: addInfo,
                permission: ['poi_create']
            }
        },
        {
            path: 'update-poi-form/:id?',
            component: () => import('@/views/GPS-Tracking/PoiManagement/poi-form'),
            name: 'UpdatePoiForm',
            hidden: true,
            meta: {
                title: 'PoiForm',
                activeMenu: '/gps-tracking/poi-management',
                parent: addInfo,
                permission: ['poi_update']
            }
        },
        // {
        //     path: 'poi-form/:id?',
        //     component: () => import('@/views/GPS-Tracking/PoiManagement/poi-form'),
        //     name: 'PoiForm',
        //     hidden: true,
        //     meta: { title: 'PoiManagement', parent: addInfo, activeMenu: '/gps-tracking/poi-management' }
        // },
        {
            path: 'map-instance',
            component: () => import('@/views/GPS-Tracking/MapInstance/map-instance.vue'),
            name: 'MapInstance',
            meta: { title: 'MapInstance', parent: addInfo, permission: ['map_instance_enable'] }
        },
        {
            path: 'map-instance-details/:id',
            component: () => import('@/views/GPS-Tracking/MapInstance/map-instance-details.vue'),
            name: 'MapInstanceDetails',
            hidden: true,
            meta: { title: 'MapInstanceDetails', parent: addInfo, enableBack: true, backPage: 'MapInstance', activeMenu: '/gps-tracking/map-instance', permission: ['map_instance_enable'] }
        },
        // {
        //     path: 'historical-playback',
        //     component: () => import('@/views/GPS-Tracking/HistoricalPlayback/historical-playback-details.vue'),
        //     name: 'HistoricalPlayback',
        //     meta: { title: 'HistoricalPlayback' },
        // },
        // {
        //     path: 'pto-log',
        //     component: () => import('@/views/GPS-Tracking/PtoLog/pto-log.vue'),
        //     name: 'PtoLog',
        //     meta: { title: 'PtoLog', parent: addInfo }
        // },
        {
            path: 'video-replay/:id?',
            component: () => import('@/views/GPS-Tracking/FullMapTracking/video-replay.vue'),
            name: 'VideoReplay',
            hidden: true,
            meta: { title: 'VideoReplay', parent: addInfo, enableBack: true, backPage: 'LiveVideo', activeMenu: '/gps-tracking/video-replay' }
        },
    ]
}

export default GPSTrackingRouter
